<!-- MIT License

Copyright (c) 2025 Brad Schick

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


-->

<div class="qcrypt">
  <mat-toolbar class="toolbar" [class.toolbar-hidden]="isWelcomePage()">
    <a [routerLink]="'/'">
      <button [style.background-color]="homeButtonColor()" mat-button class="toolbar-text">
        <mat-icon class="filled">enhanced_encryption</mat-icon>
        Quick Crypt
      </button>
    </a>
    <button [style.background-color]="helpButtonColor()" mat-button class="toolbar-text mleft15"
      #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="helpMenu" name="Help">
      <!--        (mouseover)="menuTrigger.openMenu()" -->
      Help
      <mat-icon iconPositionEnd>expand_more</mat-icon>
    </button>
    <mat-menu #helpMenu="matMenu" xPosition="after" class="toolbar-menu">
      <ng-template matMenuContent>
        <a mat-menu-item [routerLink]="'/help/overview'" name="Overview">
          Overview
        </a>
        <a mat-menu-item [routerLink]="'/help/faqs'" name="FAQs">
          FAQs
        </a>
        <a mat-menu-item [routerLink]="'/help/protocol'" name="Notation">
          Protocol Notation
        </a>
        <a mat-menu-item [routerLink]="'/help/flow'" name="Flow">
          Cipher Flow
        </a>
      </ng-template>
    </mat-menu>

    <span class="toolbar-spacer"></span>
    <button [style.visibility]="showPKButton() ? 'visible' : 'hidden'" (click)="toggleNav(sideNav)" mat-icon-button
      aria-label="Passkey information">
      <mat-icon>menu</mat-icon>
    </button>
  </mat-toolbar>
  <mat-sidenav-container class="router-content" hasBackdrop="true">
    <mat-sidenav #sideNav class="side-nav" mode="over" position="end" (opened)="onOpenedCredentials()">
      <app-credentials (done)="sideNav.close()"></app-credentials>
    </mat-sidenav>
    <mat-sidenav-content id="scrollContent" role="main">
      @if (showHalted()) {
        <app-halted />
      } @else {
        <router-outlet />
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>